import * as React from "react";
import PropTypes from "prop-types";

const LoginAlerts = ({ show }) => (
    <div className={show == true ? "legendExtended" : "legend"}>
        <div style={{ marginBottom: "5px" }}>
            <span style={{ marginRight: "20px" }} className="glyphicon glyphicon-warning-sign"/>
            Password reset needed
        </div>
        <div><span style={{ marginRight: "20px" }} className="glyphicon glyphicon-lock"/>
            Locked out of application
        </div>
    </div>
);

LoginAlerts.propTypes = {
    show: PropTypes.bool
};

LoginAlerts.defaultProps = {
    show: false
};

export default LoginAlerts;
